/* eslint-disable react/prop-types */
import { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import GlobalTableSearch from "components/organisms/DataTable/components/GlobalTableSearch";
import DataTable from "components/organisms/DataTable/DataTable";
import LocationFilter from "components/molecules/LocationFilter/LocationFilter";
import { ReactComponent as ExportIcon } from "assets/images/icons/TopNavIcons/ExportIcon.svg";
import { useGetProviderList } from "api/queries/user/useGetProviderList";
import ProviderDialog from "./ProviderDialog.tsx";
import useCommonProviderListing from "./hooks/useCommonProviderListing";

// import component

const Provider = function () {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedProvider, setSelectedProvider] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { instance, loading, totalData, popover, locationReferenceNumber, setLocationReferenceNumber, refetch } =
    useCommonProviderListing({
      useQueryHook: useGetProviderList,
    });

  return (
    <>
      <ProviderDialog
        locationReferenceNumber={locationReferenceNumber}
        isOpen={isDialogOpen}
        close={() => setIsDialogOpen(false)}
        provider={selectedProvider}
        refetch={refetch}
      />

      <DataTable
        tableInstance={instance}
        withoutBody
        totalData={totalData}
        isLoading={loading}
        draggable={false}
        onRowClick={(row) => {
          setSelectedProvider(row.original);
          setIsDialogOpen(true);
        }}
        headerLeft={
          <div className="d-md-flex justify-content-between flex-md-row flex-column w-100">
            <div className="mt-2 w-30-px">
              <GlobalTableSearch
                currentFilters={instance.state.globalFilter}
                setFilters={instance.setGlobalFilter}
                filterKey="query"
                eventContext="Provider"
              />
            </div>

            <div className="d-flex mt-3">
              <div className="cursor-pointer">
                <OverlayTrigger trigger="click" placement="bottom-end" overlay={popover} rootClose>
                  <ExportIcon />
                </OverlayTrigger>
              </div>

              <div className="ml-3" style={{ width: "192px" }}>
                <LocationFilter
                  disableAll
                  onChange={(e) => {
                    setLocationReferenceNumber(e);
                    searchParams.set("page", 1);
                    setSearchParams(searchParams);
                  }}
                />
              </div>
            </div>
          </div>
        }
      />
    </>
  );
};

export default Provider;
